import platformBackendClient from '@backend-clients/platform-backend';

export default {
  /*
    |-------------------------------------------------|
    |   @service    all                               |
    |   @params     query <String>                    |
    |   @desc       Fetches a list of teams based on  |
    |               query string                      |
    |-------------------------------------------------|
  */
  all: (query) => platformBackendClient.get(`/api/teams/?${query}`),

  /*
    |-------------------------------------------------|
    |   @service    get                               |
    |   @params     cid <String>, tid                 |
    |               <String>                          |
    |   @desc       Fetches a specific                |
    |               team based on company             |
    |               id and team id                    |
    |-------------------------------------------------|
  */
  get: (cid, tid) => platformBackendClient.get(`/api/teams/${tid}/?company_id=${cid}`),

  /*
    |-------------------------------------------------|
    |   @service    create                            |
    |   @params     cid <String>, team                |
    |               <Object>                          |
    |   @desc       Creates a new project             |
    |-------------------------------------------------|
  */
  create: (id, cid, team) => platformBackendClient.post(`/api/teams/?company_id=${id}&cid=${cid}`, team),

  /*
    |-------------------------------------------------|
    |   @service    update                            |
    |   @params     cid <String>, tid                 |
    |               <String>, updates <Object>        |
    |   @desc       Updates team data                 |
    |-------------------------------------------------|
  */
  update: (cid, id, tid, updates) => platformBackendClient.put(`/api/teams/${id}/?company_id=${cid}&tid=${tid}`, updates),

  /*
    |-------------------------------------------------|
    |   @service    delete                            |
    |   @params     cid <String>, tid <String>        |
    |   @desc       Deletes team data                 |
    |-------------------------------------------------|
  */
  delete: (cid, id, tid) => platformBackendClient.delete(`/api/teams/${id}/?company_id=${cid}&tid=${tid}`),
};
